import type { NavItem } from '@/app/nav/collect'

/**
 * The Employees menu (Employees, Teams, Organisation Chart under `on`, `hr`, `en`) is the legacy menu, declared once by
 * the shell (`src/modules/shell/nav.ts`, ids `employees*`) and already pointing at this module's paths. Legacy had no
 * other employees entry, so the module adds none.
 */
const nav: NavItem[] = []

export default nav
